import { groupBy } from "@repo/utils";
import { useNavigate, useRouterState } from "@tanstack/react-router";

import type { NavigationItem } from "~/managers/use-navigation-manager";
import { cn } from "~/lib/utils";
import { useGeneralStore } from "~/stores/use-general-store";

export function MobileMenu({ navItems }: { navItems: NavigationItem[] }) {
  const groupedNavItems = groupBy(navItems, "section");

  const { mobileNavExpanded, setMobileNavExpanded } = useGeneralStore();

  const router = useRouterState();

  const navigate = useNavigate();

  if (!mobileNavExpanded) return null;

  return (
    <nav className="absolute inset-0 flex flex-col justify-between z-[9999] bg-background">
      {Object.entries(groupedNavItems).map(([section, items]) => (
        <ul
          key={section}
          onClick={(e) => e.stopPropagation()}
          className="flex flex-wrap"
        >
          {items.map((item) => (
            <button
              onClick={() => {
                setMobileNavExpanded(false);
                void navigate({ to: item.href });
              }}
              key={item.name}
              aria-current={
                router.location.pathname === item.href ? true : false
              }
              className={cn(
                router.location.pathname === item.href &&
                  "bg-gray-200 dark:bg-bunker-800",
                "group/item min-w-[100%] flex-1 bg-background-secondary border p-2 gap-1 flex-col relative flex items-center text-foreground transition-all duration-200 hover:bg-gray-200 dark:hover:bg-bunker-800 hover:text-foreground",
              )}
            >
              {item.icon && (
                <div className="flex justify-center rounded">
                  <item.icon />
                </div>
              )}

              <span className="text-sm text-foreground transition-all group-hover/item:text-foreground group-aria-current/item:text-foreground ">
                {item.name}
              </span>
            </button>
          ))}
        </ul>
      ))}
    </nav>
  );
}
